import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LogInForm from '../../../shared/components/loginForm/LogInForm';
import { auth, authError } from '../../../redux/actions/authActions';
import REQUEST from '../../../utils/services';
import { apiUrls } from '../../../utils/api/api-urls';


const auth0Icon = 'https://icon-library.com/images/default-user-icon/default-user-icon-18.jpg';

const LogIn = ({ dispatch, history }) => {
  const { t } = useTranslation('errors');
  const navigate = useNavigate();

  const loginFn = async (data) => {
    console.log("Helloo")
    const requestdata = apiUrls.common.login;
    requestdata.data = { user: data.username, password: data.password };
    const res = await REQUEST(requestdata);
    if (res) {
      if (res?.code === '200')
      {      
        dispatch(auth({
          name: res?.modal?.data?.[0]?.user,
          avatar: auth0Icon,
        }));
        if (res?.modal?.data?.[0]?.token) {
          localStorage.setItem('easydev', res?.modal?.data?.[0]?.token);
          localStorage.setItem('easydev-user', res?.modal?.data?.[0]?.user);
        }
       navigate('/dashboard');
      }
      else {
        dispatch(authError(t(res?.notifications?.[0]?.notificationDescription)))
      }
    } else {
      dispatch(authError(t('Invalid user Please try again')));
    }
  };


  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">
              <span className="account__logo"> Rael Smart System
                {/* <span className="account__logo-accent">Improving women s lives</span> */}
              </span>
            </h3>
            <h4 className="account__subhead subhead">Data analyzing tool</h4>
          </div>
          <LogInForm
            onSubmit={loginFn}
            form="log_in_form"
          />
        </div>
      </div>
    </div>
  );
};

LogIn.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(LogIn);
